import "core-js/modules/es.array.push.js";
import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.map.js";
import "core-js/modules/esnext.iterator.some.js";
import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
  class: "content p-2"
};
const _hoisted_2 = {
  class: "text-xs mt-2"
};
const _hoisted_3 = {
  class: "text-[#F53F3F]"
};
const _hoisted_4 = {
  class: "text-right mt-3"
};
const _hoisted_5 = {
  class: "bg-white pt-6"
};
const _hoisted_6 = {
  class: "max-h-[500px] overflow-y-auto px-6 flex"
};
const _hoisted_7 = {
  class: "w-max"
};
const _hoisted_8 = {
  class: "ins-num"
};
const _hoisted_9 = {
  class: "font-medium text-gray-700 whitespace-nowrap text-right pl-2 flex-1"
};
const _hoisted_10 = {
  class: "flex-1"
};
const _hoisted_11 = {
  class: "h-[56px] flex items-center justify-center mt-6"
};
import { ElMessage, ElMessageBox } from 'element-plus';
import { ref, computed, watch } from 'vue';
import { WarningFilled } from '@element-plus/icons-vue';
import CenterDialog from '@components/CenterDialog.vue';
import { articleUpdateContent } from '@/views/home/knowledge/api/index';
import { getSensitive } from '@/views/main/api/media';
export default /*@__PURE__*/_defineComponent({
  __name: 'ArticleHandle',
  props: {
    data: {}
  },
  emits: ["refresh"],
  setup(__props, {
    emit: __emit
  }) {
    const props = __props;
    const emits = __emit;
    const bannedWords = computed(() => {
      try {
        return JSON.parse(props.data.bannedWords);
      } catch {
        return [];
      }
    });
    const visible = ref(false);
    const replacements = ref([]);
    const loading = ref(false);
    const sensitiveWords = ref([]);
    const handleReplace = async () => {
      const res = await getSensitive({
        content: replacements.value.join(',')
      });
      if (res.data.content?.length) {
        ElMessage.warning('替换词中存在违禁词，请调整');
        sensitiveWords.value.push(...res.data.content.map(x => x.wd));
        return;
      }
      if (replacements.value.some(x => !x)) {
        await ElMessageBox.confirm('检测到有替换词为空。为确保内容可正常发布，系统将把为空的违禁词统一替换为“**”。是否继续该操作？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
      }
      const {
        fileId,
        title,
        content
      } = props.data;
      const params = {
        fileId,
        fileContent: content,
        fileTitle: title,
        bannedWords: bannedWords.value.map((item, ins) => {
          return {
            wd: item.wd,
            rpl: replacements.value[ins] || '**'
          };
        })
      };
      loading.value = true;
      try {
        await articleUpdateContent(params);
        props.data.bannedWords = '';
        ElMessage.success('处理完成');
        visible.value = false;
        emits('refresh');
      } catch (err) {
        if (err.code === 511 && err.message.includes('违禁词')) {
          ElMessage.error('检测到文章中出现了新的违禁词，请继续完成处理');
          emits('refresh');
        } else {
          ElMessage.error('处理失败，请稍后再试');
        }
      } finally {
        loading.value = false;
      }
    };
    watch(bannedWords, newVal => {
      if (newVal) {
        replacements.value = newVal.map(x => x.rpl || '**');
        sensitiveWords.value.push(...newVal.map(x => x.wd));
      }
    }, {
      immediate: true
    });
    return (_ctx, _cache) => {
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_icon = _resolveComponent("el-icon");
      const _component_el_popover = _resolveComponent("el-popover");
      const _component_el_input = _resolveComponent("el-input");
      return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_el_popover, {
        placement: "top",
        "popper-class": "p-none"
      }, {
        reference: _withCtx(() => [_createVNode(_component_el_icon, {
          color: "#F53F3F",
          class: "cursor-pointer"
        }, {
          default: _withCtx(() => [_createVNode(_unref(WarningFilled))]),
          _: 1
        })]),
        default: _withCtx(() => [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_cache[3] || (_cache[3] = _createTextVNode(" 文章中包含 ", -1)), _createElementVNode("span", _hoisted_3, _toDisplayString(bannedWords.value.map(x => x.wd).join('、')), 1), _cache[4] || (_cache[4] = _createTextVNode(" 违禁词 ", -1))]), _createElementVNode("div", _hoisted_4, [_createVNode(_component_el_button, {
          type: "text",
          class: "text-xs",
          onClick: _cache[0] || (_cache[0] = $event => visible.value = true)
        }, {
          default: _withCtx(() => [...(_cache[5] || (_cache[5] = [_createTextVNode("去处理", -1)]))]),
          _: 1
        })])])]),
        _: 1
      }), visible.value ? (_openBlock(), _createBlock(CenterDialog, {
        key: 0,
        modelValue: visible.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => visible.value = $event),
        width: "520px",
        title: "违禁词处理"
      }, {
        default: _withCtx(() => [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createElementVNode("ul", _hoisted_7, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(bannedWords.value, (item, ins) => {
          return _openBlock(), _createElementBlock("li", {
            key: item,
            class: "flex items-center h-9"
          }, [_createElementVNode("span", _hoisted_8, _toDisplayString(ins + 1), 1), _createElementVNode("div", _hoisted_9, _toDisplayString(item.wd), 1)]);
        }), 128))]), _createElementVNode("ul", _hoisted_10, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(replacements.value.length, (item, ins) => {
          return _openBlock(), _createElementBlock("li", {
            key: item,
            class: "flex items-center h-9"
          }, [_cache[6] || (_cache[6] = _createElementVNode("div", {
            class: "text-[#999] text-xs mx-2 whitespace-nowrap"
          }, "替换为：", -1)), _createVNode(_component_el_input, {
            modelValue: replacements.value[ins],
            "onUpdate:modelValue": $event => replacements.value[ins] = $event,
            class: _normalizeClass({
              'is-error': sensitiveWords.value.includes(replacements.value[ins])
            }),
            placeholder: "输入替换词"
          }, null, 8, ["modelValue", "onUpdate:modelValue", "class"])]);
        }), 128))])]), _createElementVNode("div", _hoisted_11, [_createVNode(_component_el_button, {
          onClick: _cache[1] || (_cache[1] = $event => visible.value = false)
        }, {
          default: _withCtx(() => [...(_cache[7] || (_cache[7] = [_createTextVNode("取消", -1)]))]),
          _: 1
        }), _createVNode(_component_el_button, {
          type: "primary",
          loading: loading.value,
          onClick: handleReplace
        }, {
          default: _withCtx(() => [...(_cache[8] || (_cache[8] = [_createTextVNode("一键处理", -1)]))]),
          _: 1
        }, 8, ["loading"])])])]),
        _: 1
      }, 8, ["modelValue"])) : _createCommentVNode("", true)], 64);
    };
  }
});